<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import wx from 'weixin-jsapi'
import CONFIG from './utils/configuration'
export default {
    name: 'App',
    created() {
        // 微信二次分享
        let tempUrl = window.location.href
        if (tempUrl.indexOf('from') > -1) {
            tempUrl =
                tempUrl.indexOf('?from') > -1
                    ? tempUrl.split('?from')[0]
                    : tempUrl.split('&from')[0]
            window.location.href = tempUrl + '#rand=' + this.rand
        }
        this.getWeChat()
    },
    methods: {
        getWeChat() {
            let me = this
            requestDat.get({
                url: 'https://approval-api.renhuatech.com/api/v1/wechat/jsSdkSign',
                config: {
                    baseUrlType: 'approval',
                    params: {
                        url: window.location.href //URL 完整的链接
                    }
                }
            }).then((res) => {
                if (!res) return
                wx.config({
                    // debug: true,
                    appId: res.appId,
                    timestamp: res.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.nonceStr, // 必填，生成签名的随机串
                    signature: res.signature, // 必填，签名
                    jsApiList: [
                        // 用的方法都要加进来
                        'onMenuShareAppMessage',
                        'onMenuShareTimeline',
                        'updateAppMessageShareData',
                        'updateTimelineShareData'
                    ],
                    openTagList: ['wx-open-launch-weapp']
                })
                CONFIG.getWxReady()
                // wx.ready(e=>{
                //     console.log("🚀 ~ ready", e)
                // })
                // wx.error(e=>{
                //     console.log("🚀 ~ errore", e)
                // })

            })
        }
    }
}
</script>

<style>
html,
body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}

#app {
    width: 100%;
    height: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

</style>



// WEBPACK FOOTER //
// src/App.vue